
define('core/buffer_core',["require", "exports", './api_error'], function(require, exports, api_error) {
    var FLOAT_POS_INFINITY = Math.pow(2, 128);
    var FLOAT_NEG_INFINITY = -1 * FLOAT_POS_INFINITY;
    var FLOAT_POS_INFINITY_AS_INT = 0x7F800000;
    var FLOAT_NEG_INFINITY_AS_INT = -8388608;
    var FLOAT_NaN_AS_INT = 0x7fc00000;

    

    var BufferCoreCommon = (function () {
        function BufferCoreCommon() {
        }
        BufferCoreCommon.prototype.getLength = function () {
            throw new api_error.ApiError(14 /* ENOTSUP */, 'BufferCore implementations should implement getLength.');
        };
        BufferCoreCommon.prototype.writeInt8 = function (i, data) {
            this.writeUInt8(i, (data & 0xFF) | ((data & 0x80000000) >>> 24));
        };
        BufferCoreCommon.prototype.writeInt16LE = function (i, data) {
            this.writeUInt8(i, data & 0xFF);

            this.writeUInt8(i + 1, ((data >>> 8) & 0xFF) | ((data & 0x80000000) >>> 24));
        };
        BufferCoreCommon.prototype.writeInt16BE = function (i, data) {
            this.writeUInt8(i + 1, data & 0xFF);

            this.writeUInt8(i, ((data >>> 8) & 0xFF) | ((data & 0x80000000) >>> 24));
        };
        BufferCoreCommon.prototype.writeInt32LE = function (i, data) {
            this.writeUInt8(i, data & 0xFF);
            this.writeUInt8(i + 1, (data >>> 8) & 0xFF);
            this.writeUInt8(i + 2, (data >>> 16) & 0xFF);
            this.writeUInt8(i + 3, (data >>> 24) & 0xFF);
        };
        BufferCoreCommon.prototype.writeInt32BE = function (i, data) {
            this.writeUInt8(i + 3, data & 0xFF);
            this.writeUInt8(i + 2, (data >>> 8) & 0xFF);
            this.writeUInt8(i + 1, (data >>> 16) & 0xFF);
            this.writeUInt8(i, (data >>> 24) & 0xFF);
        };
        BufferCoreCommon.prototype.writeUInt8 = function (i, data) {
            throw new api_error.ApiError(14 /* ENOTSUP */, 'BufferCore implementations should implement writeUInt8.');
        };
        BufferCoreCommon.prototype.writeUInt16LE = function (i, data) {
            this.writeUInt8(i, data & 0xFF);
            this.writeUInt8(i + 1, (data >> 8) & 0xFF);
        };
        BufferCoreCommon.prototype.writeUInt16BE = function (i, data) {
            this.writeUInt8(i + 1, data & 0xFF);
            this.writeUInt8(i, (data >> 8) & 0xFF);
        };
        BufferCoreCommon.prototype.writeUInt32LE = function (i, data) {
            this.writeInt32LE(i, data | 0);
        };
        BufferCoreCommon.prototype.writeUInt32BE = function (i, data) {
            this.writeInt32BE(i, data | 0);
        };
        BufferCoreCommon.prototype.writeFloatLE = function (i, data) {
            this.writeInt32LE(i, this.float2intbits(data));
        };
        BufferCoreCommon.prototype.writeFloatBE = function (i, data) {
            this.writeInt32BE(i, this.float2intbits(data));
        };
        BufferCoreCommon.prototype.writeDoubleLE = function (i, data) {
            var doubleBits = this.double2longbits(data);
            this.writeInt32LE(i, doubleBits[0]);
            this.writeInt32LE(i + 4, doubleBits[1]);
        };
        BufferCoreCommon.prototype.writeDoubleBE = function (i, data) {
            var doubleBits = this.double2longbits(data);
            this.writeInt32BE(i + 4, doubleBits[0]);
            this.writeInt32BE(i, doubleBits[1]);
        };
        BufferCoreCommon.prototype.readInt8 = function (i) {
            var val = this.readUInt8(i);
            if (val & 0x80) {
                return val | 0xFFFFFF80;
            } else {
                return val;
            }
        };
        BufferCoreCommon.prototype.readInt16LE = function (i) {
            var val = this.readUInt16LE(i);
            if (val & 0x8000) {
                return val | 0xFFFF8000;
            } else {
                return val;
            }
        };
        BufferCoreCommon.prototype.readInt16BE = function (i) {
            var val = this.readUInt16BE(i);
            if (val & 0x8000) {
                return val | 0xFFFF8000;
            } else {
                return val;
            }
        };
        BufferCoreCommon.prototype.readInt32LE = function (i) {
            return this.readUInt32LE(i) | 0;
        };
        BufferCoreCommon.prototype.readInt32BE = function (i) {
            return this.readUInt32BE(i) | 0;
        };
        BufferCoreCommon.prototype.readUInt8 = function (i) {
            throw new api_error.ApiError(14 /* ENOTSUP */, 'BufferCore implementations should implement readUInt8.');
        };
        BufferCoreCommon.prototype.readUInt16LE = function (i) {
            return (this.readUInt8(i + 1) << 8) | this.readUInt8(i);
        };
        BufferCoreCommon.prototype.readUInt16BE = function (i) {
            return (this.readUInt8(i) << 8) | this.readUInt8(i + 1);
        };
        BufferCoreCommon.prototype.readUInt32LE = function (i) {
            return ((this.readUInt8(i + 3) << 24) | (this.readUInt8(i + 2) << 16) | (this.readUInt8(i + 1) << 8) | this.readUInt8(i)) >>> 0;
        };
        BufferCoreCommon.prototype.readUInt32BE = function (i) {
            return ((this.readUInt8(i) << 24) | (this.readUInt8(i + 1) << 16) | (this.readUInt8(i + 2) << 8) | this.readUInt8(i + 3)) >>> 0;
        };
        BufferCoreCommon.prototype.readFloatLE = function (i) {
            return this.intbits2float(this.readInt32LE(i));
        };
        BufferCoreCommon.prototype.readFloatBE = function (i) {
            return this.intbits2float(this.readInt32BE(i));
        };
        BufferCoreCommon.prototype.readDoubleLE = function (i) {
            return this.longbits2double(this.readInt32LE(i + 4), this.readInt32LE(i));
        };
        BufferCoreCommon.prototype.readDoubleBE = function (i) {
            return this.longbits2double(this.readInt32BE(i), this.readInt32BE(i + 4));
        };
        BufferCoreCommon.prototype.copy = function (start, end) {
            throw new api_error.ApiError(14 /* ENOTSUP */, 'BufferCore implementations should implement copy.');
        };
        BufferCoreCommon.prototype.fill = function (value, start, end) {
            for (var i = start; i < end; i++) {
                this.writeUInt8(i, value);
            }
        };

        BufferCoreCommon.prototype.float2intbits = function (f_val) {
            var exp, f_view, i_view, sig, sign;

            if (f_val === 0) {
                return 0;
            }

            if (f_val === Number.POSITIVE_INFINITY) {
                return FLOAT_POS_INFINITY_AS_INT;
            }
            if (f_val === Number.NEGATIVE_INFINITY) {
                return FLOAT_NEG_INFINITY_AS_INT;
            }

            if (isNaN(f_val)) {
                return FLOAT_NaN_AS_INT;
            }

            sign = f_val < 0 ? 1 : 0;
            f_val = Math.abs(f_val);

            if (f_val <= 1.1754942106924411e-38 && f_val >= 1.4012984643248170e-45) {
                exp = 0;
                sig = Math.round((f_val / Math.pow(2, -126)) * Math.pow(2, 23));
                return (sign << 31) | (exp << 23) | sig;
            } else {
                exp = Math.floor(Math.log(f_val) / Math.LN2);
                sig = Math.round((f_val / Math.pow(2, exp) - 1) * Math.pow(2, 23));
                return (sign << 31) | ((exp + 127) << 23) | sig;
            }
        };

        BufferCoreCommon.prototype.double2longbits = function (d_val) {
            var d_view, exp, high_bits, i_view, sig, sign;

            if (d_val === 0) {
                return [0, 0];
            }
            if (d_val === Number.POSITIVE_INFINITY) {
                return [0, 2146435072];
            } else if (d_val === Number.NEGATIVE_INFINITY) {
                return [0, -1048576];
            } else if (isNaN(d_val)) {
                return [0, 2146959360];
            }
            sign = d_val < 0 ? 1 << 31 : 0;
            d_val = Math.abs(d_val);

            if (d_val <= 2.2250738585072010e-308 && d_val >= 5.0000000000000000e-324) {
                exp = 0;
                sig = (d_val / Math.pow(2, -1022)) * Math.pow(2, 52);
            } else {
                exp = Math.floor(Math.log(d_val) / Math.LN2);

                if (d_val < Math.pow(2, exp)) {
                    exp = exp - 1;
                }
                sig = (d_val / Math.pow(2, exp) - 1) * Math.pow(2, 52);
                exp = (exp + 1023) << 20;
            }

            high_bits = ((sig * Math.pow(2, -32)) | 0) | sign | exp;
            return [sig & 0xFFFF, high_bits];
        };

        BufferCoreCommon.prototype.intbits2float = function (int32) {
            if (int32 === FLOAT_POS_INFINITY_AS_INT) {
                return Number.POSITIVE_INFINITY;
            } else if (int32 === FLOAT_NEG_INFINITY_AS_INT) {
                return Number.NEGATIVE_INFINITY;
            }
            var sign = (int32 & 0x80000000) >>> 31;
            var exponent = (int32 & 0x7F800000) >>> 23;
            var significand = int32 & 0x007FFFFF;
            var value;
            if (exponent === 0) {
                value = Math.pow(-1, sign) * significand * Math.pow(2, -149);
            } else {
                value = Math.pow(-1, sign) * (1 + significand * Math.pow(2, -23)) * Math.pow(2, exponent - 127);
            }

            if (value < FLOAT_NEG_INFINITY || value > FLOAT_POS_INFINITY) {
                value = NaN;
            }
            return value;
        };

        BufferCoreCommon.prototype.longbits2double = function (uint32_a, uint32_b) {
            var sign = (uint32_a & 0x80000000) >>> 31;
            var exponent = (uint32_a & 0x7FF00000) >>> 20;
            var significand = ((uint32_a & 0x000FFFFF) * Math.pow(2, 32)) + uint32_b;

            if (exponent === 0 && significand === 0) {
                return 0;
            }
            if (exponent === 2047) {
                if (significand === 0) {
                    if (sign === 1) {
                        return Number.NEGATIVE_INFINITY;
                    }
                    return Number.POSITIVE_INFINITY;
                } else {
                    return NaN;
                }
            }
            if (exponent === 0)
                return Math.pow(-1, sign) * significand * Math.pow(2, -1074);
            return Math.pow(-1, sign) * (1 + significand * Math.pow(2, -52)) * Math.pow(2, exponent - 1023);
        };
        return BufferCoreCommon;
    })();
    exports.BufferCoreCommon = BufferCoreCommon;
});
//# sourceMappingURL=buffer_core.js.map
;